import React, { useState, useEffect } from "react";
import { BiTimer } from "react-icons/bi";
import convertToHourMinute from "./ConvertToHourMinute";
import { ProgressBar } from "react-bootstrap";
import { BiTask } from "react-icons/bi";
import { AiOutlineFlag, AiFillFlag, AiOutlineTag, AiOutlineTags, AiOutlineCaretUp, AiOutlineCaretDown } from "react-icons/ai";
import { BiCheck, BiCheckCircle } from "react-icons/bi";
import moment from "moment";
import { MdCalendarToday, MdFeedback, MdTimer } from "react-icons/md";

import ellipsizeText from "./EllipsizeText";
import { getRemainingDays } from "./DaysUntilEvent";
import { getSubsubProgress } from "./subsubProgress";
import ContextMenu from "./MarkAsDoneContextMenu";
import { buildSubsubContextMenuItems } from "./subsubContextMenuItems";

const getValidUntilColor = (days) => {
    if (days <= 0) return '#ff2d44';
    if (days < 1) return '#fd7e14';
    if (days < 3) return '#ffc107';
    return '#4dabff';
};

const getSubsubExpiryDate = (subsub) => {
    const expiryDate = subsub.expiryDate || subsub.validUntil
    return expiryDate?.toDate ? expiryDate.toDate() : expiryDate
}

function RemainingTasksHome({ subtasks, currentSubSubsname, showFlaggedTasksOnly, flaggedSubTasks, flaggedDoneSubTasks, flagSubTask, flaggedSubTasksContainsSname, selectSubSub, showOnlyNonZerosAndCountUp, flagAllSubTasks, showStampWithinDateTime, taskTimeDisplayMode, onMarkSubsubDone, onAdjustSubsubTime }) {
    const [currentTime, setCurrentTime] = React.useState(moment())
    const [tagInfo, setTagInfo] = React.useState([])
    const [isShimmering, setIsShimmering] = useState(false)
    const [contextMenu, setContextMenu] = useState({ visible: false, anchorRect: null, parentSubtask: null, subsub: null })
    const isElapsedMode = taskTimeDisplayMode === 'elapsed'

    const getSubsubProgressStyle = (workedRatio) => {
        const percent = workedRatio * 100
        return {
            '--progress-percent': `${percent}%`
        }
    }

    const hideActiveTaskFromList = (tasks) => {
        let tasksExtended = Object.assign([], tasks)
        return tasksExtended.filter((t) => {
            if (t.sname == currentSubSubsname) {
                return false
            } else {
                return true
            }
        })
    }

    const determiningTheClassNameOfExpiryDate = (expiryDate) => {
        // ensure expiryDate is not null or undefined
        if (expiryDate == null || expiryDate == undefined) {
            return ''
        }
        let d = moment(expiryDate.toDate()).diff(moment(), 'days')
        if (d <= 1) {
            return 'ExpiryDateRed'
        } else if (d <= 7) {
            return 'ExpiryDateYellow'
        } else {
            return 'ExpiryDateGreen'
        }
    }

    const getUniqueTagsFromSubtasks = (subtasks) => {
        let tagName = []
        let tags = []
        if (!subtasks) {
            return []
        }
        subtasks.map((t) => {
            if (t.validFromDate != null) {
                if (moment(t.validFromDate.toDate()).isAfter(moment())) {
                    return // skip this subtask because it is not valid yet (validFromDate is in the future)
                }
            }
            // Date range filter for tags
            if (showStampWithinDateTime && t.hasOwnProperty('validFromDate') && t.validFromDate !== null) {
                if (moment(t.validFromDate.toDate()).isAfter(moment(showStampWithinDateTime))) {
                    return; 
                }
            }

            let subsubsToConsiderForTags = t.subsubs || [];
            if (showStampWithinDateTime) {
                subsubsToConsiderForTags = (t.subsubs || []).filter(it => {
                    const subsubExpiryDate = getSubsubExpiryDate(it)
                    if (subsubExpiryDate) {
                        return !moment(subsubExpiryDate).isAfter(moment(showStampWithinDateTime));
                    }
                    return true; // include if no expiry date
                });
            }
            
            // If showStampWithinDateTime is active, and the stamp itself has no date, 
            // but all its subsubs are filtered out, don't include its tags.
            if (showStampWithinDateTime && (!t.hasOwnProperty('validFromDate') || t.validFromDate === null) && t.hasOwnProperty('subsubs') && t.subsubs.length > 0 && subsubsToConsiderForTags.length === 0) {
                return;
            }


            if (t.tags) {
                const remainingMinutesForStamp = Number(t.finish ?? 0) * 50
                const plannedUnitsForStamp = Number(t.initialFinish ?? t.finish ?? 0)
                const elapsedMinutesForStamp = Math.max(0, (plannedUnitsForStamp - Number(t.finish ?? 0)) * 50)
                const minutesForStamp = isElapsedMode ? elapsedMinutesForStamp : remainingMinutesForStamp
                t.tags.split(',').map((tag) => {
                    if (tagName.indexOf(tag) == -1) {
                        tags.push({
                            tag: tag,
                            minutes: minutesForStamp
                        })
                        tagName.push(tag)
                    } else {
                        tags[tagName.indexOf(tag)].minutes += minutesForStamp
                    }
                })
            }
        })
        return tags
    }

    useEffect(() => {
        let tags = getUniqueTagsFromSubtasks(subtasks)
        setTagInfo(tags)
    }, [subtasks, showStampWithinDateTime, taskTimeDisplayMode])


    const flagManySubTasks = (subtask) => {
        try {
            let subsubs = subtask.subsubs
            const snames = subsubs.map((s) => {
                return s.name
            })
            flagAllSubTasks(subtask.sname, snames)
        } catch (e) {
            console.log(e)
        }
    }

    const handleContextMenu = (e, parentSubtask, subsub) => {
        e.preventDefault()
        e.stopPropagation()
        const rect = e.currentTarget.getBoundingClientRect()
        setContextMenu({
            visible: true,
            anchorRect: { left: rect.left, top: rect.top, bottom: rect.bottom, width: rect.width },
            parentSubtask,
            subsub
        })
    }

    const closeContextMenu = () => {
        setContextMenu((prev) => ({ ...prev, visible: false }))
    }

    const onSubSubClick = async (parentSubtask, subsub) => {
        if (!onMarkSubsubDone) {
            return
        }
        try {
            setIsShimmering(true)
            await onMarkSubsubDone(parentSubtask, subsub)
        } finally {
            setIsShimmering(false)
        }
    }

    const adjustCurrentSubsubTime = async (action) => {
        if (!contextMenu.subsub || !contextMenu.parentSubtask || !onAdjustSubsubTime) {
            return
        }
        try {
            setIsShimmering(true)
            await onAdjustSubsubTime(contextMenu.parentSubtask, contextMenu.subsub, action)
        } finally {
            setIsShimmering(false)
        }
    }

    const subsubContextMenuItems = buildSubsubContextMenuItems({
        onMarkDone: async () => {
            if (contextMenu.parentSubtask && contextMenu.subsub) {
                await onSubSubClick(contextMenu.parentSubtask, contextMenu.subsub)
            }
        },
        onAdjustTime: async (action) => {
            await adjustCurrentSubsubTime(action)
        }
    })

    return (<>
        {hideActiveTaskFromList(subtasks).map((item) => {
            // Filter 1: if item has validFromDate property and it is in the future (past currentTime), then don't show it
            if (item.hasOwnProperty('validFromDate') && moment(item.validFromDate.toDate()).isAfter(moment(currentTime))) {
                return (<React.Fragment key={item.sname + '_frag1'}></React.Fragment>)
            }

            // Filter 2: if showStampWithinDateTime is set, and item has validFromDate, it must be BEFORE or ON showStampWithinDateTime
            if (showStampWithinDateTime && item.hasOwnProperty('validFromDate') && item.validFromDate !== null) {
                if (moment(item.validFromDate.toDate()).isAfter(moment(showStampWithinDateTime))) {
                    return (<React.Fragment key={item.sname + '_frag2'}></React.Fragment>); // Stamp's validFromDate is after the filter date
                }
            }

            let subsubsToDisplay = [];
            if (item.hasOwnProperty('subsubs')) {
                subsubsToDisplay = item.subsubs.filter(it => {
                    // Sub-filter 1: standard showFlaggedTasksOnly logic
                    if (showFlaggedTasksOnly && (flaggedDoneSubTasks.indexOf(item.sname + it.name) > -1 || flaggedSubTasks.indexOf(item.sname + it.name) === -1)) {
                        return false;
                    }
                    if (showOnlyNonZerosAndCountUp) {
                        const plannedUnits = Number(it.initialFinish ?? it.time ?? it.finish ?? 0) || 0;
                        if (plannedUnits < 0.000001) {
                            return false;
                        }
                    }

                    // Sub-filter 2: if showStampWithinDateTime is set, and sub-sub has an expiry date, it must be BEFORE or ON showStampWithinDateTime
                    // Sub-subs are relevant if their expiry date is within the range OR if they don't have one (considered always relevant for an active stamp)
                    const subsubExpiryDate = getSubsubExpiryDate(it)
                    if (showStampWithinDateTime && subsubExpiryDate) {
                        if (moment(subsubExpiryDate).isAfter(moment(showStampWithinDateTime))) {
                            return false; // Sub-sub's expiry date is after the filter date
                        }
                         // Also check if sub-sub's expiry date is before now (already passed) - though primary logic is based on showStampWithinDateTime
                        if (moment(subsubExpiryDate).isBefore(moment(currentTime))) {
                             // If we want to hide sub-subs that have already passed their validUntil, even if before showStampWithinDateTime
                             // return false; // Uncomment this line if past sub-subs should be hidden
                        }
                    }
                    return true; // Passes all sub-filters
                });
            }

            // Filter 3: If showStampWithinDateTime is active:
            // A. If the stamp itself was NOT filtered out by Filter 2 (i.e., it's generally in range or has no date itself)
            // B. AND it has subsubs defined
            // C. BUT all of those subsubs were filtered out (e.g., by their own validUntil or other filters)
            // THEN, hide the parent stamp.
            if (showStampWithinDateTime && item.hasOwnProperty('subsubs') && item.subsubs.length > 0 && subsubsToDisplay.length === 0) {
                return (<React.Fragment key={item.sname + '_frag3'}></React.Fragment>);
            }
            
            // Filter 4: If showStampWithinDateTime is set, and the item has no subsubs at all (item.subsubs is undefined or empty)
            // AND it also does not have a validFromDate (meaning its validity isn't explicitly defined by a date for this filter),
            // then we should not show it. It implies this item is too broad.
            // However, if it *does* have a validFromDate that fell within the range (passed Filter 2), it should be shown even without subsubs.
            if (showStampWithinDateTime && (!item.hasOwnProperty('subsubs') || item.subsubs.length === 0)) {
                if (!item.hasOwnProperty('validFromDate') || item.validFromDate === null) {
                    // No subsubs AND no specific date for the stamp itself to be in range -> hide if date filter active
                    return (<React.Fragment key={item.sname + '_frag4'}></React.Fragment>); 
                }
                // If it reached here, it has a validFromDate that was in range (passed Filter 2), so show it.
            }


            if (item.hasOwnProperty('countUp') && item.countUp === 1) {
                if (showFlaggedTasksOnly && !flaggedSubTasksContainsSname(item.sname)) {
                    return (<React.Fragment key={item.sname + '_countup_flagged'}></React.Fragment>)
                }
                // If countUp item has subsubs, and all are filtered out by date (subsubsToDisplay is empty), don't show the countUp item.
                if (showStampWithinDateTime && item.hasOwnProperty('subsubs') && item.subsubs.length > 0 && subsubsToDisplay.length === 0) {
                    return (<React.Fragment key={item.sname + '_countup_subsubs_date'}></React.Fragment>);
                }
                 // If countUp item has no subsubs, and showStampWithinDateTime is active, and it has no validFromDate, hide it.
                if (showStampWithinDateTime && (!item.hasOwnProperty('subsubs') || item.subsubs.length === 0) && (!item.hasOwnProperty('validFromDate') || item.validFromDate === null)) {
                    return (<React.Fragment key={item.sname + '_countup_no_subsubs_no_date'}></React.Fragment>);
                }
                return (
                    <React.Fragment key={item.sname + '_countup'}>
                        <div className={`SubTaskHome SubTaskHomeRemaining`}>
                            <div className={`${showFlaggedTasksOnly ? "TitleLeft" : "Title"}`} style={{ flexDirection: 'column' }}>

                                <div onClick={() => selectSubSub(item)}>{showFlaggedTasksOnly ? <span style={{ marginRight: 10 }}><BiTask></BiTask></span> : <></>}<span>{item.sname}</span> {item.allowFeedback > 0 ? <MdFeedback></MdFeedback> : <></>}</div>
                                {!showFlaggedTasksOnly && <div>
                                    <span><AiOutlineFlag onClick={() => flagManySubTasks(item)}></AiOutlineFlag> <BiTimer></BiTimer> {item.hasOwnProperty('tuCounted') ? item.tuCounted : ''}</span>
                                    <span>{item.hasOwnProperty("expiryDate") && (<>• <span className="ExpiryDateSub" style={{ color: getValidUntilColor(getRemainingDays(item.expiryDate.toDate())) }}><MdCalendarToday></MdCalendarToday> {getRemainingDays(item.expiryDate.toDate()).toFixed(1)}</span></>)
                                    }</span>
                                </div>}


                            </div>
                            {(item.hasOwnProperty("time")) && !showFlaggedTasksOnly ? (<ProgressBar style={{ marginTop: 7 }} now={item.finish < 0 ? 100 : 100 - ((item.finish * 2 * (25 * 60 * 1000) / 60000) / ((item.initialFinish + 0.000001) * 2 * (25 * 60 * 1000) / 60000) * 100)}></ProgressBar>) : (<></>)}
                            {item.hasOwnProperty('subsubs') && subsubsToDisplay.map((it) => {
                                const progress = getSubsubProgress(it)
                                const subsubProgressStyle = getSubsubProgressStyle(progress.workedRatio)
                                const isCompleted = progress.workedRatio >= 1
                                const remainingMinutes = progress.remainingDisplay * 50
                                const elapsedMinutes = Math.max(0, (progress.planned - progress.remainingDisplay) * 50)
                                const minutesToDisplay = isElapsedMode ? elapsedMinutes : remainingMinutes
                                const shouldShowTime = progress.planned > 0 && (remainingMinutes >= 1 || elapsedMinutes >= 1)
                                const subsubExpiryDate = getSubsubExpiryDate(it)
                                return (
                                    <div key={item.sname + it.name} style={{...subsubProgressStyle, position: 'relative'}} className={`subtaskEntry ${it.name.startsWith('*') && (!it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'green' :
                                        ((it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'yellow' : (it.name.startsWith('***') ? 'red' : ''))}`}>
                                        <span className={`subtaskFlag`} onClick={() => flagSubTask(item.sname, it.name)}> {flaggedSubTasks.indexOf(item.sname + it.name) === -1 ? <AiOutlineFlag></AiOutlineFlag> : (flaggedDoneSubTasks.indexOf(item.sname + it.name) === -1 ? <AiFillFlag></AiFillFlag> : <BiCheck></BiCheck>)} </span> <span className={`${isShimmering ? 'shimmer' : ''}`} onContextMenu={(e) => handleContextMenu(e, item, it)}> {it.name.replace(/#|\*/g, '')}</span>{' '}
                                        {shouldShowTime && (
                                            <>
                                                <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                                                    {convertToHourMinute(minutesToDisplay)}
                                                    <span style={{ marginLeft: 2 }}>
                                                        {isElapsedMode ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                                                    </span>
                                                </span>
                                            </>
                                        )}
                                        {subsubExpiryDate && (
                                            <>
                                                {shouldShowTime && ' / '}
                                                <span style={{opacity: 0.8, color: getValidUntilColor(getRemainingDays(subsubExpiryDate))}}>
                                                    {getRemainingDays(subsubExpiryDate).toFixed(1)} <MdCalendarToday style={{ marginLeft: 1 }} />
                                                </span>
                                            </>
                                        )}
                                        {isCompleted && (
                                            <>
                                                <span style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    top: 0,
                                                    bottom: 0,
                                                    width: '60px',
                                                    background: 'linear-gradient(to right, transparent, rgba(45, 55, 72, 1) 70%)',
                                                    pointerEvents: 'none',
                                                    borderRadius: '0 3px 3px 0'
                                                }}></span>
                                                <span style={{position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', color: '#48BB78', fontSize: '1.1em'}}><BiCheckCircle /></span>
                                            </>
                                        )}
                                    </div>
                                )
                            })}
                            {item.tags && item.tags !== '' && <div className="TagAreaOfSubTask">
                                <AiOutlineTag style={{ marginRight: 10 }}></AiOutlineTag> <span>{
                                    item.tags ? item.tags.split(',').map((t) => {
                                        return (<span key={item.sname + '_tag_' + t} className={`tag ${t}`}>{ellipsizeText(t, 3)}</span>)
                                    }) : ''
                                }</span>
                            </div>}
                        </div>
                    </React.Fragment>
                )
            }
            // normal subtask display with time
            if (showFlaggedTasksOnly && !flaggedSubTasksContainsSname(item.sname)) {
                return (<React.Fragment key={item.sname + '_normal_flagged'}></React.Fragment>)
            }
            const plannedUnits = Number(item.initialFinish ?? item.finish ?? 0) || 0
            if (showOnlyNonZerosAndCountUp && plannedUnits < 0.000001) {
                return (<React.Fragment key={item.sname + '_normal_non_zero'}></React.Fragment>) 
            }
            // If normal item has subsubs, and all are filtered out by date, don't show the item.
            // This was already covered by Filter 3, but re-checking specifically for non-countUp items.
            if (showStampWithinDateTime && item.hasOwnProperty('subsubs') && item.subsubs.length > 0 && subsubsToDisplay.length === 0) {
                 return (<React.Fragment key={item.sname + '_normal_subsubs_date'}></React.Fragment>);
            }
             // If normal item has no subsubs, and showStampWithinDateTime is active, and it has no validFromDate, hide it.
            // This was already covered by Filter 4.
            if (showStampWithinDateTime && (!item.hasOwnProperty('subsubs') || item.subsubs.length === 0) && (!item.hasOwnProperty('validFromDate') || item.validFromDate === null)) {
                return (<React.Fragment key={item.sname + '_normal_no_subsubs_no_date'}></React.Fragment>);
            }

            const stampRemainingMinutes = Number(item.finish ?? 0) * 50
            const stampPlannedUnits = Number(item.initialFinish ?? item.finish ?? 0)
            const stampElapsedMinutes = Math.max(0, (stampPlannedUnits - Number(item.finish ?? 0)) * 50)
            const stampMinutesToDisplay = isElapsedMode ? stampElapsedMinutes : stampRemainingMinutes

            return (
                <React.Fragment key={item.sname + '_normal'}>
                    <div className={`SubTaskHome SubTaskHomeRemaining`}>
                        <div className={`${showFlaggedTasksOnly ? "TitleLeft" : "Title"} ${item.finish < 0 ? "TitleRouge" : ""}`} style={{ flexDirection: 'column' }}>
                            <div onClick={() => selectSubSub(item)}>{showFlaggedTasksOnly ? <span style={{ marginRight: 10 }}><BiTask></BiTask></span> : <></>}<span>{item.sname}</span> {item.allowFeedback > 0 ? <MdFeedback></MdFeedback> : <></>}</div>
                            {!showFlaggedTasksOnly && <div>
                                <span style={{ marginLeft: 5, marginRight: 5 }}>
                                    <AiOutlineFlag onClick={() => flagManySubTasks(item)}></AiOutlineFlag> <MdTimer></MdTimer>
                                    {item.hasOwnProperty("time") && (
                                        <>
                                            {' '}
                                            {convertToHourMinute(stampMinutesToDisplay)}
                                            <span style={{ marginLeft: 2, opacity: 0.7 }}>
                                                {isElapsedMode ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                                            </span>
                                        </>
                                    )}
                                </span>
                                <span>{item.hasOwnProperty("expiryDate") && (<> • <span className={`ExpiryDateSub ${determiningTheClassNameOfExpiryDate(item.expiryDate)}`}><MdCalendarToday></MdCalendarToday> {getRemainingDays(item.expiryDate.toDate()).toFixed(1)}</span></>)
                                }</span>
                            </div>}


                        </div>
                        {(item.hasOwnProperty("time")) && !showFlaggedTasksOnly ? (<ProgressBar style={{ marginTop: 7 }} now={item.finish < 0 ? 100 : 100 - ((item.finish * 2 * (25 * 60 * 1000) / 60000) / ((item.initialFinish + 0.000001) * 2 * (25 * 60 * 1000) / 60000) * 100)}></ProgressBar>) : (<></>)}
                            {item.hasOwnProperty('subsubs') && subsubsToDisplay.map((it) => {
                                const progress = getSubsubProgress(it)
                                const subsubProgressStyle = getSubsubProgressStyle(progress.workedRatio)
                                const isCompleted = progress.workedRatio >= 1
                                const remainingMinutes = progress.remainingDisplay * 50
                                const elapsedMinutes = Math.max(0, (progress.planned - progress.remainingDisplay) * 50)
                                const minutesToDisplay = isElapsedMode ? elapsedMinutes : remainingMinutes
                                const shouldShowTime = progress.planned > 0 && (remainingMinutes >= 1 || elapsedMinutes >= 1)
                                const subsubExpiryDate = getSubsubExpiryDate(it)
                                return (
                                    <div key={item.sname + it.name} style={{...subsubProgressStyle, position: 'relative'}} className={`subtaskEntry ${it.name.startsWith('*') && (!it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'green' :
                                        ((it.name.startsWith('**')) && (!it.name.startsWith('***')) ? 'yellow' : (it.name.startsWith('***') ? 'red' : ''))}`}>
                                        <span className={`subtaskFlag`} onClick={() => flagSubTask(item.sname, it.name)}> {flaggedSubTasks.indexOf(item.sname + it.name) === -1 ? <AiOutlineFlag></AiOutlineFlag> : (flaggedDoneSubTasks.indexOf(item.sname + it.name) === -1 ? <AiFillFlag></AiFillFlag> : <BiCheck></BiCheck>)} </span> <span className={`${isShimmering ? 'shimmer' : ''}`} onContextMenu={(e) => handleContextMenu(e, item, it)}> {it.name.replace(/#|\*/g, '')}</span>{' '}
                                        {shouldShowTime && (
                                            <>
                                                <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                                                    {convertToHourMinute(minutesToDisplay)}
                                                    <span style={{ marginLeft: 2 }}>
                                                        {isElapsedMode ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                                                    </span>
                                                </span>
                                            </>
                                        )}
                                        {subsubExpiryDate && (
                                            <>
                                                {shouldShowTime && ' / '}
                                                <span style={{opacity: 0.8, color: getValidUntilColor(getRemainingDays(subsubExpiryDate))}}>
                                                    {getRemainingDays(subsubExpiryDate).toFixed(1)} <MdCalendarToday style={{ marginLeft: 1 }} />
                                                </span>
                                            </>
                                        )}
                                        {isCompleted && (
                                            <>
                                                <span style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    top: 0,
                                                    bottom: 0,
                                                    width: '60px',
                                                    background: 'linear-gradient(to right, transparent, rgba(45, 55, 72, 1) 70%)',
                                                    pointerEvents: 'none',
                                                    borderRadius: '0 3px 3px 0'
                                                }}></span>
                                                <span style={{position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', color: '#48BB78', fontSize: '1.1em'}}><BiCheckCircle /></span>
                                            </>
                                        )}
                                    </div>
                                )
                            })}
                        {item.tags && item.tags !== '' && <div className="TagAreaOfSubTask">
                            <AiOutlineTag style={{ marginRight: 10 }}></AiOutlineTag> <span>{
                                item.tags ? item.tags.split(',').map((t) => {
                                    return (<span key={item.sname + '_tag_' + t} className={`tag ${t}`}>{ellipsizeText(t, 3)}</span>)
                                }) : ''
                            }</span>
                        </div>}
                    </div>
                </React.Fragment>
            )
        })}
        <ContextMenu
            visible={contextMenu.visible}
            anchorRect={contextMenu.anchorRect}
            onClose={closeContextMenu}
            menuItems={subsubContextMenuItems}
        />
        <div className="TimeRemainingByTag">
            {tagInfo.map((tag) => {
                return (
                    <div key={tag.tag + '_time_by_tag'} className="TimeRemainingByTagEntry">
                        <span className={`tag ${tag.tag}`}>{ellipsizeText(tag.tag, 3)}</span>
                        <span>
                            {convertToHourMinute(tag.minutes)}
                            <span style={{ marginLeft: 2, opacity: 0.7 }}>
                                {isElapsedMode ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                            </span>
                        </span>
                    </div>
                )
            })}
        </div>
    </>)
}

export default React.memo(RemainingTasksHome);
